import { FC } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, Typography } from '@mui/material';

import Utils from '../../../../../components/Utils';
import { CampaignFlight } from '../../../../../types/Campaign';

interface LinkedFlightsTableProps {
    flights: CampaignFlight[];
    allFlights: CampaignFlight[];
}

const LinkedFlightsTable: FC<LinkedFlightsTableProps> = ({ flights, allFlights }) => {
    // Calculate flight number based on position in the original flights list
    const getFlightNumber = (flight: CampaignFlight): number => {
        const index = allFlights.findIndex((f) => f.id === flight.id);
        return allFlights.length - index;
    };

    if (!flights || flights.length === 0) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    No linked flights found
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer
            sx={{
                width: '100%',
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
            }}
        >
            <Table sx={{ width: '100%' }}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Flight</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                            Budget
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                            Start Date
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                            End date
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {flights.map((flight) => (
                        <TableRow
                            key={flight.id}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                            }}
                        >
                            <TableCell component="th" scope="row">
                                {getFlightNumber(flight)}
                            </TableCell>
                            <TableCell align="right">
                                {flight.budgetAmount ? Utils.formatCurrency(flight.budgetAmount) : '-'}
                            </TableCell>
                            <TableCell align="right">{Utils.formatESTDate(flight.startDateTime)}</TableCell>
                            <TableCell align="right">{Utils.formatESTDate(flight.endDateTime)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LinkedFlightsTable;
